import Image from 'next/image';

import { Container, Title, LogoContainer } from './we-built-this.elements';

import regulusLogo from '@/assets/svg/regulus-logo.svg';

const WeBuiltThis = () => {
  return (
    <Container>
      <Title>Dizajn i izrada</Title>
      <LogoContainer>
        <a href="https://regulus.systems" target="_blank" rel="noreferrer noopener">
          <Image
            src={regulusLogo}
            alt="Regulus"
            height="60"
            style={{ objectFit: 'cover', maxWidth: '100%', height: 'auto' }}
          />
        </a>
      </LogoContainer>
    </Container>
  );
};

export { WeBuiltThis };
